import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { Dialog } from 'components/common';
import Points from 'assets/rewards/points.png';

const useStyles = makeStyles((theme) => ({
  content: {
    borderRadius: '16px',
    background: '#FAFAFC',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '24px',
    alignItems: 'center',
  },
  title: {
    fontSize: '28px',
    fontWeight: 700,
  },
  subtitle: {
    fontSize: '14px',
  },
  earnedTitle: {
    fontWeight: 700,
    color: theme.palette.primary.main,
  },
  earnedPoints: {
    fontSize: '32px',
    color: theme.palette.primary.main,
  },
  pointsImage: {
    width: '39px',
    height: '39px',
  },
  pointsWithImage: {
    display: 'flex',
    alignItems: 'center',
  },
  pointsContainer: {
    padding: '12px 0',
    backgroundColor: '#FFFFFF',
    borderRadius: '16px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
  },
  imageContainer: {
    minWidth: '215px',
    minHeight: '215px',
    backgroundColor: '#FFFFFF',
    borderRadius: '140px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  actions: {
    '& .MuiButton-root': {
      textTransform: 'none',
    },
  },
  image: {
    maxWidth: '183px',
    maxHeight: '183px',
  },
}));

interface BadgeData {
  badgeId: string;
  notificationId: string;
  title: string;
  body: string;
  points: number;
  iconUrl?: string;
}

interface Props {
  open: boolean;
  onCancel: () => void;
  data?: BadgeData;
}

const BadgeUnlockedDialog = ({ open, onCancel, data }: Props) => {
  const classes = useStyles();

  return (
    <Dialog
      title="Congratulations!"
      onCancel={onCancel}
      onClose={onCancel}
      confirmText="Keep going"
      open={open}
      onConfirm={onCancel}
      showCancelButton={false}
      confirmSize={12}
      dialogProps={{ BackdropProps: { invisible: true } }}
      confirmUppercase={false}>
      <Box className={classes.content}>
        <Box className={classes.imageContainer}>
          <img src={data?.iconUrl} alt="" className={classes.image} />
        </Box>
        <Typography className={classes.title}>{data?.title}</Typography>
        <Typography className={classes.subtitle}>{data?.body}</Typography>
        <Box className={classes.pointsContainer}>
          <Typography className={classes.earnedTitle}>You earned</Typography>
          <Box className={classes.pointsWithImage}>
            <img className={classes.pointsImage} src={Points} alt="" />
            <Typography className={classes.earnedPoints}>{data?.points}</Typography>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default BadgeUnlockedDialog;
